import {User}                                                       from "@shared/classes/user";
import {EnumOuiNon}                                                 from "@shared/enums/enumOuiNon";
import {TypeProjetEnum}                                             from "@shared/enums/typeProjetEnum";
import {getAge}                                                     from "@shared/helper/DateHelper";
import {arrayIsNotNull, arrayIsNull, stringIsNotNull, stringIsNull} from "@shared/helper/LDHelper";
import {QueryParams}                                                from "../../shared/queryParams/queryParams";
import {CHECK_STEP_ONE}                                             from "./main.constants";

const FIELDS = [
  TypeProjetEnum.OBSEQUES,
  TypeProjetEnum.GAV,
  TypeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT,
  TypeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE,
  "PETITS_ENFANTS_MOINS_18_ANS",
  "ENFANTS"
];


const CONTROL_VALUES = {
  [TypeProjetEnum.OBSEQUES]:                             (user: User, next: boolean, queryParams: QueryParams): boolean => {
    let isOk = true;
    if (next && stringIsNull (user.OBSEQUES)) {
      isOk = false;
    }
    return isOk;
  },
  [TypeProjetEnum.GAV]:                                  (user: User, next: boolean, queryParams: QueryParams): boolean => {
    let isOk = true;
    if (next && stringIsNull (user.GAV)) {
      isOk = false;
    }
    return isOk;
  },
  [TypeProjetEnum.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT]: (user: User, next: boolean, queryParams: QueryParams): boolean => {
    let isOk = true;
    if (next && stringIsNull (user.EMPRUNT_IMMOBILIER_OR_PROJET_EMPRUNT)) {
      isOk = false;
    }
    return isOk;
  },
  [TypeProjetEnum.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE]:   (user: User, next: boolean, queryParams: QueryParams): boolean => {
    let isOk = true;
    if (next && stringIsNull (user.EMPRUNT_OR_PROJET_SUP_QUINZE_MILLE)) {
      isOk = false;
    }
    return isOk;
  },
  PETITS_ENFANTS_MOINS_18_ANS:                           (user: User, next: boolean, queryParams: QueryParams): boolean => {
    let isOk = true;
    if (next && stringIsNull (user.enfantsMoinsDixHuitAns)) {
      isOk = false;
    }
    return isOk;
  },
  ENFANTS:                                               (user: User, next: boolean, queryParams: QueryParams): boolean => {
    const elements = user.datesNaissanceEnfants;
    let isOk       = true;
    if (user.enfant === EnumOuiNon.OUI && (arrayIsNull (elements) ||
                                           (arrayIsNotNull (elements) && elements.filter (e => stringIsNotNull (e)).length === 0))) {
      isOk = false;
    }
    return isOk;
  }
};


export class HelperMain {

  static check (user: User, queryParams: QueryParams): string {
    let isOk = true;
    for (let i = 0; i < FIELDS.length && isOk; i++) {
      const key   = FIELDS[i];
      const check = CHECK_STEP_ONE[key];
      if (!check) {
        throw new Error (`key in check / CHECK_STEP_ONE not found => [${key}]....`);
      }
      const age     = getAge (user.dateDeNaissance);
      const next    = check (user, age, queryParams);
      const control = CONTROL_VALUES[key];
      if (!control) {
        throw new Error (`key in check / CONTROL_VALUES not found => [${key}]....`);
      }
      isOk = control (user, next, queryParams);
      if (!isOk) {
        console.log (`check false for key [${key}]....`);
      }
    }
    return (
      isOk ? EnumOuiNon.OUI : null
    );
  }


}
